import { crudService } from '../_services'
import { stringUtils } from 'utils'
import { toast } from 'react-toastify'

export const notificacaoFiltroAction = {
  getNotificacaoFiltro,
  addNotificacaoFiltro,
  getNotificacaoFiltroById,
  onChangeProps,
  handleOnChangeProps,
  changeNotificacaoFiltrosList,
  /*editNotificacaoFiltroInfo,*/
  editNotificacaoFiltrosDetails,
  deleteNotificacaoFiltrosDetails,
  createNotificacaoFiltro,
  createNotificacaoFiltroInfo,
  updatedNotificacaoFiltroInfo,
  deleteNotificacaoFiltroById,
  clear,
  clearAll,
  clearInfo,
  isLoading,
  notIsLoading
}


function getNotificacaoFiltro(filterModel) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'notificacoesFiltros' + stringUtils.serialize(filterModel);
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(changeNotificacaoFiltrosList(response.data.items, response.data.totalRows))
        dispatch(notIsLoading())
      })
      .catch((err) => {
        dispatch(notIsLoading())
        console.log(err)
      })
  }
}

function createNotificacaoFiltro(payload) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'notificacoesFiltros/'
    crudService.post(apiEndpoint, payload).then(() => {
      dispatch(createNotificacaoFiltroInfo())
      toast.success('Feito! Cadastro realizado com sucesso! 😎')
      dispatch(getNotificacaoFiltroByNotificacao(payload.idNotificacao))
      dispatch(notIsLoading())
    })
  }
}

function getNotificacaoFiltroById(id) {
  return (dispatch) => {
    let apiEndpoint = 'notificacoesFiltros/' + id
    crudService.get(apiEndpoint).then((response) => {   
      dispatch(editNotificacaoFiltrosDetails(response.data))
    })
  }
}

function getNotificacaoFiltroByNotificacao(id) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'notificacoesFiltros/notificacao/' + id
    crudService.get(apiEndpoint).then((response) => {     
      dispatch(changeNotificacaoFiltrosList(response.data, 0))
      dispatch(notIsLoading())
    })
  }
}

function onChangeProps(props, event) {
  return (dispatch) => {
    if (event.target.type === 'checkbox') {
      dispatch(handleOnChangeProps(props, event.target.checked))
    } else {
      dispatch(handleOnChangeProps(props, event.target.value))
    }
  }
}

//function editNotificacaoFiltroInfo(id, payload, redirect) {
//  return (dispatch) => {
//    let apiEndpoint = 'notificacoesFiltros/' + id
//    crudService.put(apiEndpoint, payload).then(() => {
//      dispatch(updatedNotificacaoFiltroInfo())
//      dispatch(clear())
//      if (redirect) {
//        history.push('/notificacoesFiltros')
//      }
//    })
//  }
//}

function deleteNotificacaoFiltroById(id) {
  return (dispatch) => {
    let apiEndpoint = 'notificacoesFiltros/' + id
    crudService.deleteDetail(apiEndpoint).then((response) => {
      var ret = JSON.parse(response.request.responseText);
      dispatch(deleteNotificacaoFiltrosDetails())
      dispatch(getNotificacaoFiltroByNotificacao(ret.key))
    })
  }
}

function addNotificacaoFiltro(payload) {
  return [{ type: 'ADD_NOTIFICACAO_FILTRO', notificacaoFiltro: payload }, clear()]
}

function changeNotificacaoFiltrosList(notificacaoFiltro, totalRows) {
  return {
    type: 'FETCHED_ALL_NOTIFICACAO_FILTRO',
    notificacaoFiltro: notificacaoFiltro,
    totalRegistros: totalRows
  }
}

function clear() {
  return {
    type: 'NOTIFICACAO_FILTRO_CLEAR'
  }
}

function clearAll() {
  return {
    type: 'NOTIFICACAO_FILTRO_CLEAR_ALL'
  }
}

function clearInfo() {
  return {
    type: 'NOTIFICACAO_FILTRO_CLEAR_INFO'
  }
}

function handleOnChangeProps(props, value) {
  return {
    type: 'NOTIFICACAO_FILTRO_HANDLE_ON_CHANGE',
    props: props,
    value: value
  }
}

function editNotificacaoFiltrosDetails(notificacaoFiltro) {
  return [
    { type: 'NOTIFICACAO_FILTRO_DETAIL', notificacaoFiltro },
  ]
}

function updatedNotificacaoFiltroInfo() {
  return {
    type: 'NOTIFICACAO_FILTRO_UPDATED'
  }
}

function createNotificacaoFiltroInfo() {
  return {
    type: 'NOTIFICACAO_FILTRO_CREATED_SUCCESSFULLY'
  }
}

function deleteNotificacaoFiltrosDetails() {
  return {
    type: 'DELETED_NOTIFICACAO_FILTRO_DETAILS'
  }
}

function isLoading() {
  return {
    type: 'NOTIFICACAO_FILTRO_ISLOADING'
  }
}

function notIsLoading() {
  return {
    type: 'NOTIFICACAO_FILTRO_NOTISLOADING'
  }
}
